const config = {
  screens: {
    Home: {
      path: "/home",
    },
    Register: {
      path: "/register",
    },
    Login: {
      path: "/login",
    },
    StudentRegister: {
      path: "/student-register",
    },
    VerifyOtp: {
      path: "/verify-otp",
    },
    Verification: {
      path: "/verify",
    },
    Trip: {
      path: "/trips",
    },
    UserProfile: {
      path: "/user-profile",
    },
    ShowTripInfo: {
      path: "/trip-info",
    },
    Reset_Password: {
      path: "/reset-password",
    },
    Company_Review: {
      path: "/company-review",
    },
  },
};

const linking = {
  prefixes: ["http://localhost:19006"],
  config,
};

export default linking;
